import React, {useEffect, useMemo, useState} from "react";
import "./../../utils/Style/pages/Banktransfers.scss";
import { useTable, usePagination } from "react-table";
import { faArrowDown, faGreaterThan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TableSelect from "../../components/TableSelect";
import s2S_API from "../../api/S2S_API";
import Pagination from "../../components/Pagination";
import TransferListSkeleton from "../../components/skeletons/TransferListSkeleton";
import TransactionDetails from "../../components/TransactionDetails";
import UtcToLocal from "../../components/UtcToLocal";
import DatePicker from "../../components/DatePicker";
import RecordsMessage from "../../components/RecordsMessage";
import {useSelector} from "react-redux";
import RepeatTransaction from "../../components/ReapeatTransaction";
import {capitalizeFirstLetters, formatLBP, formatUSD} from "../../features/ValueFormater";

function SuyooltoSuyoolTemplate({ setActiveButton }) {
    const {GetS2STransfersList, s2sData, s2sLoading, totalNbOfPage, totalCount} = s2S_API();
    const {flag} = useSelector((state)=> state.transferResponse);

    const [activeRowIndex, setActiveRowIndex] = useState(-1);
    const [visible, setVisible] = useState(false);
    const [totalNbPage, SetTotalNbPage] = useState(1);
    const [selectedPage, setSelectedPage] = useState(1);
    const [s2sList, setS2sList] = useState([]);
    const [amountDetails, setAmountDetails] = useState(null);
    const [transactionId, setTransactionId] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    const [dateRange, setDateRange] = useState([
        new Date(new Date().setMonth(new Date().getMonth() - 1)),
        new Date(),
    ]);

    const [dateString, setDateString] = useState({
        startDateString: "",
        endDateString: ""
    })

    useEffect(() => {
        if(dateRange) {
            const startDate = new Date(Date.UTC(dateRange[0].getUTCFullYear(), dateRange[0].getUTCMonth(), dateRange[0].getUTCDate()));
            const endDate = new Date(Date.UTC(dateRange[1].getUTCFullYear(), dateRange[1].getUTCMonth(), dateRange[1].getUTCDate()));
            const startDateString = startDate.toISOString().substring(0, 10);
            const endDateString = endDate.toISOString().substring(0, 10);

            setDateString({
                startDateString,
                endDateString
            });

            GetS2STransfersList(1, startDateString, endDateString);

            if([0, 1].includes(flag)){
                setTimeout(()=>{
                    GetS2STransfersList(1, startDateString, endDateString);
                }, 1000)
            }
        }
    }, [dateRange, flag]);

    useEffect(() => {
        if (s2sData) {
            setS2sList(s2sData);
            SetTotalNbPage(totalNbOfPage);
        }
    }, [s2sData]);

    const data = useMemo(() => s2sList, [s2sList]);

    const options = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    };
    function handleRepeatTransaction(id) {
        setTransactionId(id);
        setModalOpen(true);
    }

    const columns = useMemo(
        () => [
            {
                Header: "Transfer",
                accessor: "Transaction",
                Cell: ({ value }) => {
                    return <div>Transfer {value}</div>;
                }
            },
            {
                Header: "Date",
                accessor: "Date",
                Cell: ({cell: {value}}) => {
                    return <UtcToLocal utcTimestamp={value} options={options}/>
                },
            },
            {
                Header: "",
                accessor: "details",
                Cell: ({ row }) => {
                    return <button className="showmore" onClick={() => { setActiveRowIndex(row.index) }}><FontAwesomeIcon icon={faArrowDown} /></button>
                },
            },
            {
                Header: "Recipient",
                accessor: "Recipient",
                Cell: ({value})=>{
                    return capitalizeFirstLetters(value);
                }
            },
            {
                Header: "Amount",
                accessor: "Amount",
                Cell: ({row, value}) =>{
                    if (row.original.Currency === 'USD') return <div>$ {formatUSD(value)}</div>
                    else return <div>L.L {formatLBP(value)}</div>
                }
            },
            {
                Header: "Reason",
                accessor: "Reason",
                Cell: ({value})=>(
                    <div id="reason">{value}</div>
                )
            },
            {
                Header: "Attached File",
                accessor: "AttachedFile",
            },
            {
                Header: "Status",
                accessor: "Status",
                Cell: ({ cell: { value } }) => {
                    if (value === "Pending") {
                        return <button style={{ color: "white", fontFamily: "Poppins Medium", fontSize: "12px", backgroundColor: "#D3AA00", borderRadius: "20px", width: "46%", padding: "3px 0" }}>{capitalizeFirstLetters(value)}</button>;
                    } else if (value === "Successful") {
                        return <button style={{ color: "white", fontFamily: "Poppins Medium", fontSize: "12px", backgroundColor: "#199B2D", borderRadius: "20px", width: "46%", padding: "3px 0" }}>{capitalizeFirstLetters(value)}</button>;
                    } else if (value === "Declined") {
                        return <button style={{ color: "white", fontFamily: "Poppins Medium", fontSize: "12px", backgroundColor: "#D32127", borderRadius: "20px", width: "46%", padding: "3px 0" }}>{capitalizeFirstLetters(value)}</button>;
                    } else {
                        return <UtcToLocal utcTimestamp={value} options={options}/>;
                    }
                },
            },
            {
                Header: "",
                accessor: "Action",
                key: "Action",
                Cell: ({ row }) => {
                    if(row.original.Status !== "Pending" && row.original.Status !== "Declined"&& sessionStorage.getItem("EntityRole")!=="VIEWER")
                    return <button
                        id="repeat-btn"
                        onClick={()=>handleRepeatTransaction(row.original.Transaction)}
                    >Repeat</button>;
                    else return <></>
                }
            },
            {
                Header: "",
                accessor: "AS",
                Cell: ({ row }) => {
                    return <button onClick={() => {
                        setAmountDetails({
                            Amount: row.original.Amount,
                            Balance: row.original.Balance,
                            Method: row.original.Method,
                            PaymentDate: row.original.PaymentDate,
                            Transaction: row.original.Transaction,
                        })
                        setVisible(true)
                        setActiveRowIndex(row.index)
                    }} ><FontAwesomeIcon icon={faGreaterThan} /></button>;
                },
            }
        ],
        []
    );


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow
    } = useTable({ columns, data: data || [] }, usePagination);

    return (
        <>
            {
                !s2sLoading? (
                    <div className={activeRowIndex === -1 ? "col-12" : "col-8"}>
                        <div className="tableTop">
                            <RecordsMessage totalCount={totalCount} selectedPage={selectedPage} records="transactions"/>
                            <div className="filtering">
                                <DatePicker
                                    value={dateRange}
                                    onChange={setDateRange}
                                />
                                <select className="ddselect" name="account" id="account">
                                    <option value="USD">All Transfers</option>
                                </select>
                                {
                                    sessionStorage.getItem("EntityRole")!== "VIEWER" ? (
                                        <button className="export" onClick={() => {
                                            setActiveButton({ name: "+ New Free Transfer" });
                                        }}>+ NEW TRANSFER</button>
                                    ) : ( <></>)
                                }
                            </div>
                        </div>

                        <TableSelect
                            headerGroups={headerGroups}
                            page={page}
                            prepareRow={prepareRow}
                            getTableProps={getTableProps}
                            getTableBodyProps={getTableBodyProps}
                            activeRowIndex={activeRowIndex}
                            setActiveRowIndex={setActiveRowIndex}
                            setAmountDetails={setAmountDetails}
                            setVisible={setVisible}
                            totalNbPage={totalNbPage}
                        />
                        <Pagination
                            getData={GetS2STransfersList}
                            totalNbPage={totalNbPage}
                            method="s2s"
                            startDateString={dateString.startDateString}
                            endDateString={dateString.endDateString}
                            selectedPage={selectedPage}
                            setSelectedPage={setSelectedPage}
                        />
                    </div>
                ) : (
                    <TransferListSkeleton/>
                )
            }

            <TransactionDetails
                activeRowIndex={activeRowIndex}
                setActiveRowIndex={setActiveRowIndex}
                visible={visible}
                setVisible={setVisible}
                TransactionID={amountDetails}
            />
            <RepeatTransaction transactionID={transactionId} modalOpen={modalOpen} setModalOpen={setModalOpen}/>
        </>
    );
}
export default SuyooltoSuyoolTemplate;